import React from 'react'
import { motion } from 'framer-motion'

const PrivacyPage = () => {
  return (
    <div className="pt-16 lg:pt-20 min-h-screen">
      <section className="section-padding py-20">
        <div className="container-max max-w-4xl mx-auto">
          <motion.h1 className="text-4xl font-display font-bold text-white mb-6" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>Privacy Policy</motion.h1>
          <div className="glass-card p-8 space-y-4 text-white/80">
            <p>We respect your privacy. We collect only what is necessary to operate the platform and improve your experience. We never sell personal data.</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Accounts: email, username, basic profile</li>
              <li>Events & marketplace: content you submit</li>
              <li>Analytics: anonymized usage for performance and UX</li>
            </ul>
            <p>For data requests or deletion, contact hello@littleeddieaudio.com.</p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default PrivacyPage

